import { CITY } from '@city'
import { ConsentRecordCookies } from './ConsentRecordCookies'
import { showConsentWindow } from '../../cookie/inMobiChoice'

/**
 * The cookie policy of a city with web analytics (`CITY.webAnalytics`):
 * the cookies set by each category, their retention, the cookieless
 * counting that runs before consent, and a button to re-open the consent
 * window (PECR revocability requirement).
 */
export function AnalyticsCookiePolicy() {
  return (
    <>
      <p>
        Cookies are small text files set by the sites you visit. Below is the list of cookies we (or
        our analytics partners) may set on {CITY.domain}.
      </p>

      <h2>Strictly necessary (always on)</h2>
      <table style={{ width: '100%', borderCollapse: 'collapse' }}>
        <thead>
          <tr>
            <th align="left">Name</th>
            <th align="left">Purpose</th>
            <th align="left">Retention</th>
          </tr>
        </thead>
        <tbody>
          <ConsentRecordCookies />
        </tbody>
      </table>

      <h2>Analytics (only if you consent)</h2>
      <table style={{ width: '100%', borderCollapse: 'collapse' }}>
        <thead>
          <tr>
            <th align="left">Name</th>
            <th align="left">Provider</th>
            <th align="left">Purpose</th>
            <th align="left">Retention</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>
              <code>_ga</code>, <code>_gid</code>
            </td>
            <td>Google Analytics 4</td>
            <td>Anonymous usage statistics (IP anonymised).</td>
            <td>up to 14 months</td>
          </tr>
          <tr>
            <td>
              <code>AMP_*</code>
            </td>
            <td>Amplitude</td>
            <td>Anonymous product-usage statistics.</td>
            <td>up to 12 months</td>
          </tr>
        </tbody>
      </table>

      <h2>Without your consent</h2>
      <p>
        Until you accept analytics, Google Analytics 4 and Amplitude count visits without cookies or
        any other storage on your device, and without your IP address. Amplitude groups one
        visitor&apos;s page views within a day by a pseudonymous identifier our server derives from
        your network and browser with a key it discards every day.
      </p>

      <h2>Change your choice</h2>
      <p>
        <button type="button" onClick={showConsentWindow}>
          Open cookie settings
        </button>
      </p>
    </>
  )
}
